export default "__VITE_ASSET__DeVjg4ny__"